import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import ListingSelectionBody from './ListingSelectionBody';

const View = (props) => <ListingSelectionBody {...props} />;

export default withBlockExtensions(View);
